import { render } from "./contractBlock.vue?vue&type=template&id=78055d2a&scoped=true"
import script from "./contractBlock.vue?vue&type=script&lang=js"
export * from "./contractBlock.vue?vue&type=script&lang=js"

import "./contractBlock.vue?vue&type=style&index=0&id=78055d2a&lang=scss&scoped=true"
import "./contractBlock.vue?vue&type=style&index=1&id=78055d2a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78055d2a"]])

export default __exports__